import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDownload, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:9009/api'

// ---------------------------------- 1. ข้อมูลโครงการตามรอบการพิจารณา
export const getProjectconsiderlist = () => {
  // /api/files/criteria/projectconsiderlist
  const url = `${API_ROOT}/files/criteria/projectconsiderlist`
  return doGet(url)
}

export const searchProjectconsiderlist = (request) => {
  // /api/files/preview/projectconsiderlist
  const url = `${API_ROOT}/files/preview/projectconsiderlist`
  return doPost(url, request)
}

export const downloadProjectconsiderlist = (request) => {
  // /api/files/download/projectconsiderlist
  const url = `${API_ROOT}/files/download/projectconsiderlist`
  return doPostDownload(url, request)
}

// ---------------------------------- 2.1 รายงานโครงการก่อนที่ได้รับการอนุมัติ
export const getProjectbeforeapprovelist = () => {
  // /api/files/criteria/projectbeforeapprovelist
  const url = `${API_ROOT}/files/criteria/projectbeforeapprovelist`
  return doGet(url)
}

export const searchProjectbeforeapprovelist = (request) => {
  // /api/files/preview/projectbeforeapprovelist
  const url = `${API_ROOT}/files/preview/projectbeforeapprovelist`
  return doPost(url, request)
}

export const downloadProjectbeforeapprovelist = (request) => {
  // /api/files/download/projectbeforeapprovelist
  const url = `${API_ROOT}/files/download/projectbeforeapprovelist`
  return doPostDownload(url, request)
}

// ---------------------------------- 2.2 รายงานโครงการที่ได้รับการอนุมัติ
export const getProjectalreadyapprovelist = () => {
  // /api​/report​/criteria​/projectalreadyapprovelist
  const url = `${API_ROOT}/files/criteria/projectalreadyapprovelist`
  return doGet(url)
}

export const searchProjectalreadyapprovelist = (request) => {
  // /api/files/preview/projectalreadyapprovelist
  const url = `${API_ROOT}/files/preview/projectalreadyapprovelist`
  return doPost(url, request)
}

export const downloadProjectalreadyapprovelist = (request) => {
  // ​/api​/report​/download​/projectalreadyapprovelist
  const url = `${API_ROOT}/files/download/projectalreadyapprovelist`
  return doPostDownload(url, request)
}

// ---------------------------------- 3. รายงานโครงการที่ยัง Active แยกรายประเด็น
export const getProjectissuelist = () => {
  // /api/files/criteria/projectissuelist
  const url = `${API_ROOT}/files/criteria/projectissuelist`
  return doGet(url)
}

export const searchProjectissuelist = (request) => {
  // /api/files/preview/projectissuelist
  const url = `${API_ROOT}/files/preview/projectissuelist`
  return doPost(url, request)
}

export const downloadProjectissuelist = (request) => {
  // /api/files/download/projectissuelist
  const url = `${API_ROOT}/files/download/projectissuelist`
  return doPostDownload(url, request)
}

// ---------------------------------- 4.รายงานโครงการที่เปลี่ยนสถานะเป็นดำเนินการ
export const getProjectoperationlist = () => {
  // /api/files/criteria/projectoperationlist
  const url = `${API_ROOT}/files/criteria/projectoperationlist`
  return doGet(url)
}

export const searchProjectoperationlist = (request) => {
  // /api​/report​/preview​/projectoperationlist
  const url = `${API_ROOT}/files/preview/projectoperationlist`
  return doPost(url, request)
}

export const downloadProjectoperationlist = (request) => {
  // /api/files/download/projectoperationlist
  const url = `${API_ROOT}/files/download/projectoperationlist`
  return doPostDownload(url, request)
}

// ---------------------------------- 5.รายงานติดตามโครงการของศูนย์สัญญา
export const getProjectcontractfollowuplist = () => {
  // /api/files/criteria/projectcontractfollowuplist
  const url = `${API_ROOT}/files/criteria/projectcontractfollowuplist`
  return doGet(url)
}

export const searchProjectcontractfollowuplist = (request) => {
  // /api/files/preview/projectcontractfollowuplist
  const url = `${API_ROOT}/files/preview/projectcontractfollowuplist`
  return doPost(url, request)
}

export const downloadProjectcontractfollowuplist = (request) => {
  // /api/files/download/projectcontractfollowuplist
  const url = `${API_ROOT}/files/download/projectcontractfollowuplist`
  return doPostDownload(url, request)
}

// ---------------------------------- 6.การติดตามโครงการ
export const getProjectfollowuplist = () => {
  // /api/files/criteria/projectfollowuplist
  const url = `${API_ROOT}/files/criteria/projectfollowuplist`
  return doGet(url)
}

export const searchProjectfollowuplist = (request) => {
  // /api/files/preview/projectfollowuplist
  const url = `${API_ROOT}/files/preview/projectfollowuplist`
  return doPost(url, request)
}

export const downloadProjectfollowuplist = (request) => {
  // /api/files/download/projectfollowuplist
  const url = `${API_ROOT}/files/download/projectfollowuplist`
  return doPostDownload(url, request)
}

// ---------------------------------- 7.รายงานโครงการปิดล่าช้า
export const getProjectclosurelist = () => {
  // /api/files/criteria/projectclosurelist
  const url = `${API_ROOT}/files/criteria/projectclosurelist`
  return doGet(url)
}

export const searchProjectclosurelist = (request) => {
  // /api/files/preview/projectclosurelist
  const url = `${API_ROOT}/files/preview/projectclosurelist`
  return doPost(url, request)
}

export const downloadProjectclosurelist = (request) => {
  // /api/files/download/projectclosurelist
  const url = `${API_ROOT}/files/download/projectclosurelist`
  return doPostDownload(url, request)
}

// ---------------------------------- 8.รายงานการเบิกจ่ายโครงการแยกรายงวด
export const getProjectpaymentform = () => {
  // ​//api/files/criteria/projectpaymentlist
  const url = `${API_ROOT}/files/criteria/projectpaymentlist`
  return doGet(url)
}

export const searchProjectpaymentform = (request) => {
  // /api/files/preview/projectpaymentlist
  const url = `${API_ROOT}/files/preview/projectpaymentlist`
  return doPost(url, request)
}

export const downloadProjectpaymentlist = (request) => {
  // /api/files/download/projectpaymentlist
  const url = `${API_ROOT}/files/download/projectpaymentlist`
  return doPostDownload(url, request)
}

// ---------------------------------- 9.รายงานโครงการย่อย
export const getSubprojectlist = () => {
  // ​/api​/report​/criteria​/subprojectlist
  const url = `${API_ROOT}/files/criteria/subprojectlist`
  return doGet(url)
}

export const searchSubprojectlist = (request) => {
  // /api/files/preview/subprojectlist
  const url = `${API_ROOT}/files/preview/subprojectlist`
  return doPost(url, request)
}

export const downloadSubprojectlist = (request) => {
  // ​/api​/report​/download​/subprojectlist
  const url = `${API_ROOT}/files/download/subprojectlist`
  return doPostDownload(url, request)
}

// ---------------------------------- 10.พิมพ์ที่อยู่จัดส่งเอกสาร
export const getShippingaddressform = () => {
  // /api/files/criteria/shippingaddress
  const url = `${API_ROOT}/files/criteria/shippingaddress`
  return doGet(url)
}

export const searchShippingaddressform = (request) => {
  // /api/files/preview/shippingaddress
  const url = `${API_ROOT}/files/preview/shippingaddress`
  return doPost(url, request)
}

export const downloadShippingaddressform = (request) => {
  // /api/files/download/shippingaddressform
  const url = `${API_ROOT}/files/download/shippingaddressform`
  return doPostDownload(url, request)
}

// ---------------------------------- 11.รายงานโครงการที่อนุมัติ+ในท่อ (รายโครงการ)
export const getProjectApproved = () => {
  // /api/files/criteria/projectapproved
  const url = `${API_ROOT}/files/criteria/projectapproved`
  return doGet(url)
}

export const searchProjectApproved = (request) => {
  // /api/files/preview/projectapproved
  const url = `${API_ROOT}/files/preview/projectapproved`
  return doPost(url, request)
}

export const downloadProjectApproved = (request) => {
  // /api/files/download/projectapproved
  const url = `${API_ROOT}/files/download/projectapproved`
  return doPostDownload(url, request)
}

// ---------------------------------- 12.รายงานโครงการที่ยัง Active สำหรับศูนย์สัญญา
export const getActiveProject = () => {
  // /api/files/criteria/activeproject
  const url = `${API_ROOT}/files/criteria/activeproject`
  return doGet(url)
}

export const searchActiveProject = (request) => {
  // /api/files/preview/activeproject
  const url = `${API_ROOT}/files/preview/activeproject`
  return doPost(url, request)
}

export const downloadActiveProject = (request) => {
  // /api/files/download/activeproject
  const url = `${API_ROOT}/files/download/activeproject`
  return doPostDownload(url, request)
}

// ---------------------------------- 13.รายงานโครงการที่รอศูนย์สัญญาปีดโครงการ
export const getProjectWaitingForClose = () => {
  // /api/files/criteria/projectwaitingforclose
  const url = `${API_ROOT}/files/criteria/projectwaitingforclose`
  return doGet(url)
}

export const searchProjectWaitingForClose = (request) => {
  // /api/files/preview/projectwaitingforclose
  const url = `${API_ROOT}/files/preview/projectwaitingforclose`
  return doPost(url, request)
}

export const downloadProjectWaitingForClose = (request) => {
  // /api/files/download/projectwaitingforclose
  const url = `${API_ROOT}/files/download/projectwaitingforclose`
  return doPostDownload(url, request)
}

// ---------------------------------- 14.โครงการที่ปิดโครงการแล้ว สำหรับศูนย์สัญญา
export const getProjectClose = () => {
  // /api/files/criteria/projecclose
  const url = `${API_ROOT}/files/criteria/projectclose`
  return doGet(url)
}

export const searchProjectClose = (request) => {
  // /api/files/preview/projectclose
  const url = `${API_ROOT}/files/preview/projectclose`
  return doPost(url, request)
}

export const downloadProjectClose = (request) => {
  // /api/files/download/projecclose
  const url = `${API_ROOT}/files/download/projectclose`
  return doPostDownload(url, request)
}

// ---------------------------------- 15.โครงการที่ได้รับการอนุมัติ สำหรับศูนย์สัญญา
export const getProjectGrent = () => {
  // /api/files/criteria/projectgrant
  const url = `${API_ROOT}/files/criteria/projectgrant`
  return doGet(url)
}

export const searchProjectGrent = (request) => {
  // /api/files/preview/projectgrant
  const url = `${API_ROOT}/files/preview/projectgrant`
  return doPost(url, request)
}

export const downloadProjectGrent = (request) => {
  // /api/files/preview/projectgrant
  const url = `${API_ROOT}/files/download/projectgrant`
  return doPostDownload(url, request)
}

// ---------------------------------- 16.ข้อมูลผู้รับผิดชอบโครงการหรือผู้รับทุน
export const getProjectGranteeBasicInfo = () => {
  const url = `${API_ROOT}/files/criteria/granteebasicinfo`
  return doGet(url)
}

export const searchProjectGranteeBasicInfo = (request) => {
  const url = `${API_ROOT}/files/preview/granteebasicinfo`
  return doPost(url, request)
}

export const exportProjectGranteeBasicInfo = (request) => {
  // /api/files/download/granteebasicinfo
  const url = `${API_ROOT}/files/download/granteebasicinfo`
  return doPostDownload(url, request)
}

// ---------------------------------- 17. โครงการทั้งหมด
export const getProjectAllDetail = () => {
  const url = `${API_ROOT}/files/criteria/proposalalldetail`
  return doGet(url)
}

export const searchProjectAllDetail = (request) => {
  const url = `${API_ROOT}/files/preview/proposalalldetail`
  return doPost(url, request)
}

export const exportProjectAllDetail = (request) => {
  const url = `${API_ROOT}/files/download/proposalalldetail`
  return doPostDownload(url, request)
}

// ---------------------------------- 18. ค้นหารายงานค้างจ่ายเกินกำหนดรายงวด
export const getOverduePaymenPeriod = () => {
  const url = `${API_ROOT}/files/criteria/overduepaymentperiod`
  return doGet(url)
}

export const searchOverduePaymenPeriod = (request) => {
  const url = `${API_ROOT}/files/preview/overduepaymentperiod`
  return doPost(url, request)
}

export const downloadOverduePaymenPeriod = (request) => {
  const url = `${API_ROOT}/files/download/overduepaymentperiod`
  return doPostDownload(url, request)
}

// ---------------------------------- 18. รายงานภาระผูกพันรายงวด

export const getObligationOfInstallment = () => {
  // /api/files/criteria/obligationperiod
  const url = `${API_ROOT}/files/criteria/obligationperiod`
  return doGet(url)
}

export const searchObligationOfInstallment = (request) => {
  // /api/files/preview/obligationperiod
  const url = `${API_ROOT}/files/preview/obligationperiod`
  return doPost(url, request)
}

export const downloadObligationOfInstallment = (request) => {
  const url = `${API_ROOT}/files/download/obligationperiod`
  return doPostDownload(url, request)
}

// ---------------------------------- 18. รายงานภาระผูกพัน
// const _API_ROOT = 'http://localhost:80/api'
export const getObligation = () => {
  const url = `${API_ROOT}/files/criteria/obligation`
  return doGet(url)
}

export const searchObligation = (request) => {
  const url = `${API_ROOT}/files/preview/obligation`
  return doPost(url, request)
}

export const downloadObligation = (request) => {
  const url = `${API_ROOT}/files/download/obligation`
  return doPostDownload(url, request)
}

// --------------------
export const getBudgetApprovalReport = () => {
  const url = `${API_ROOT}/files/criteria/budget-approval-report`
  return doGet(url)
}

export const searchBudgetApprovalReport = (request) => {
  const url = `${API_ROOT}/files/preview/budget-approval-report`
  return doPost(url, request)
}

export const downloadBudgetApprovalReport = (request) => {
  const url = `${API_ROOT}/files/download/budget-approval-report`
  return doPostDownload(url, request)
}

export const getProjectVender = (pageNumber, pageSize) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/contract/vender/page/${pageNumber}/${pageSize}`
  return doGet(url)
}

export const searchProjectVender = (pageNumber, pageSize, request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/contract/vender/page/${pageNumber}/${pageSize}`
  return doPost(url, request)
}

export const exportVender = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/files/download/venders`
  return doPostDownload(url, request)
}

export const getConfirmActualResult = (
  projectCode = '',
  projectName = '',
  pageNumber = 1,
  pageSize = 10
) => {
  // const API_ROOT = 'http://localhost:80/api'
  const url = `${API_ROOT}/progress/confirm-actual-result-page?projectCode=${projectCode}&projectName=${projectName}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}

export const exportConfirmActualResult = (ProjectCode) => {
  // const API_ROOT = 'http://localhost:80/api'
  // http://localhost/api/files/download/confirm-actual-result?ProjectCode=dddd
  const url = `${API_ROOT}/files/download/confirm-actual-result?ProjectCode=${ProjectCode}`
  return doPostDownload(url, {})
}

export const getProjectBudgetPlanReport = () => {
  const url = `${API_ROOT}/files/criteria/project-budget-plan-report`
  return doGet(url)
}

export const searchProjectBudgetPlanReport = (request) => {
  const url = `${API_ROOT}/files/preview/project-budget-plan-report`
  return doPost(url, request)
}

export const downloadProjectBudgetPlanReport = (request) => {
  const url = `${API_ROOT}/files/download/project-budget-plan-report`
  return doPostDownload(url, request)
}

export const GetLogActivity = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  // http://localhost/api/proposal/report/activity-logs
  const url = `${API_ROOT}/proposal/report/activity-logs`
  return doPost(url, request)
}

export const exportLogActivityExcel = (request) => {
  // const API_ROOT = 'http://localhost:80/api'
  // http://localhost/api/files/download/confirm-actual-result?ProjectCode=dddd
  const url = `${API_ROOT}/files/download/log-activity-report`
  return doPostDownload(url, request)
}
// ---------------------------------- 24. ภาพรวมการเบิกจ่ายและเงินเหลือคืนของเงินอุดหนุนโครงการ

// const API_ROOT2 = 'http://localhost:9009/api'
export const getOverallDisbursement = () => {
  const url = `${API_ROOT}/files/criteria/overalldisbursement`
  return doGet(url)
}

export const searchOverallDisbursement = (request) => {
  const url = `${API_ROOT}/files/preview/overalldisbursement`
  return doPost(url, request)
}

export const downloadOverallDisbursement = (request) => {
  const url = `${API_ROOT}/files/download/overalldisbursement`
  return doPostDownload(url, request)
}
